module.exports = __webpack_public_path__ + "img/xunmeng.dcf804a.png";